import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../core/helper/auth.guard";
import { Guardiancomponent } from "./guardian.component";
import { PageNotFoundComponent } from "../../page-not-found.component";
import { OnlineSessionComponent } from "../forms/shared-modals/online-session/online-session.component";



const guardianRoutes: Routes = [
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: Guardiancomponent,
    children: [
      {
        component: OnlineSessionComponent,
        path: "online-session",
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
      },

      {
        loadChildren: "./main/main.module#MainModule",
        path: "main",
      },
      {
        loadChildren:
          "../Parent-Portal/dairy/homework/homework.module#HomeworkModule",
        path: "PDailyHomework",
      },
      {
        loadChildren:
          "../Parent-Portal/dairy/Circular/Circular.module#CircularModule",
        path: "PCircular",
      },
      {
        loadChildren:
          "../Parent-Portal/dairy/Message/Message.module#MessageModule",
        path: "PMessage",
      },
      {
        loadChildren:
          "../Parent-Portal/parentonlinesession/parentonlinesession.module#parentonlinesessionModule",
        path: "OnlineClass",
      },
      {
        loadChildren:
          "./dairy/assignment/Assignment.module#AssignmentModule",
        path: "PAssignment",
      },
      {
        loadChildren:
          "./feechallan/feechallan.module#FeechallanModule",
        path: "feechallan",
      },
      {
        loadChildren:
          "./Pcommunication/communication.module#CommunicationModule",
        path: "Communication",
      },

      {
        loadChildren:
          "./pattentance/pattendance.module#PattendanceModule",
        path: "StuAttendance",
      },
      {
        loadChildren:
          "./subject/subject.module#subjectModule",
        path: "Subject",
      },
      {
        loadChildren:
          "./PTimetable/PTimetable.module#PTimetableModule",
        path: "TimeTable",
      },
      {
        loadChildren:
          "./passessment/passessment.module#PassessmentModule",
        path: "assessment",
      },
      {
        loadChildren:
          "./classwork/classwork.module#ClassworkModule",
        path: "classwork",
      },
      {
        loadChildren:
          "./parentptm/request/request.module#RequestModule",
        path: "Request",
      },
      {
        loadChildren:
          "./parentptm/Schedule/Schedule.module#ScheduleModule",
        path: "Schedule",
      },
      

      {
        loadChildren:
          "./parentonlineassessment/parentonlineassessment.module#ParentonlineassessmentModule",
        path: "onlineassessment",
      },



    ],
  },
  {
    component: PageNotFoundComponent,
    path: '**',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
  }
];



@NgModule({
  imports: [RouterModule.forChild(guardianRoutes)],
  exports: [RouterModule,
  ],


})
export class GuardianRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/shell/Parent-Portal/guardian.routing.ts